<mat-toolbar color="accent">Allocate Transaction</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content fxLayout="column">
    <pr-attributed-to-selector
      class="flex grow"
      formControlName="attributedTo"
      [staff]="staff"
      [invoice]="data.invoice"
    />
  </mat-dialog-content>

  <mat-dialog-actions>
    <pt-buttons-container padding="none">
      <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" [disabled]="form.invalid">
        Allocate
      </button>
    </pt-buttons-container>
  </mat-dialog-actions>
</form>
